// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"Checkbox_checkmark__uYzjw","checked":"Checkbox_checked__GRFlk","errorCheckmark":"Checkbox_errorCheckmark__oJV60"};